module.exports = __webpack_public_path__ + "img/main_slide_3.d4bf3c0b.png";